import { Typography } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import MDBox from "components/MDBox";

import { formatDateEndOfDay } from "helpers/formatDate";

import { Inscrito } from "interfaces/atleta";

import InscricaoStatus from "layouts/pages/inscricoes/componets/InscricaoStatus";

interface Props {
  inscricoes: Inscrito[];
}
export default function TableInscricaoAtleta({ inscricoes }: Props) {
  const columns: GridColDef<Inscrito>[] = [
    {
      field: "evento",
      headerName: "Evento",
      width: 320,
      disableColumnMenu: true,
      renderCell(params) {
        return (
          <MDBox display="flex" flexDirection="column">
            <Typography variant="body2">{params.row.evento.titulo}</Typography>
            <Typography variant="caption">
              {formatDateEndOfDay(params.row.evento.dataEvento)}
            </Typography>
          </MDBox>
        );
      },
    },
    {
      field: "numeroInscricao",
      headerName: "N. Insc.",
      width: 210,
      disableColumnMenu: true,
      renderCell(params) {
        return (
          <MDBox display="flex" flexDirection="column">
            <Typography variant="body2">
              {params.row.inscricao.numeroInscricao}
            </Typography>
            <Typography variant="caption">
              Resp. Insc. {params.row.inscricao.nomeResponsavel}
            </Typography>
          </MDBox>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      width: 200,
      headerAlign: "center",
      align: "center",
      disableColumnMenu: true,
      renderCell(params) {
        return (
          <InscricaoStatus status={params.row.inscricao.statusInscricao.tipo} />
        );
      },
    },
    {
      field: "categoria",
      headerName: "Categoria",
      width: 200,
      disableColumnMenu: true,
      renderCell(params) {
        return (
          <MDBox display="flex" flexDirection="column">
            <Typography variant="body2">
              {params.row.categoria.distancia.descricao}
            </Typography>
            <Typography variant="caption">
              {params.row.categoria.descricao}
            </Typography>
          </MDBox>
        );
      },
    },
  ];

  return (
    <MDBox>
      <DataGrid
        getRowId={(row) => row.inscricao.id}
        columns={columns}
        rows={inscricoes}
      />
    </MDBox>
  );
}
